import React from "react";
import PrettyButton from "@components/common/PrettyButton";
import { TestTheTestBrandLink } from "@components/common/TestTheTestBrandLink";
import { Box, Stack, Typography, Container, styled } from "@mui/material";
import { InvitedText } from "./InvitedText";

export const Background = styled("div")({
  backgroundImage: 'url("/assets/images/signup-bg.png")',
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  minHeight: "100dvh", // looks a bit better on mobile when the browser has a top & bottom bar (eg Chrome's tab groups)
});

interface Props {
  onClickCreate: () => void;
  inviteToken?: string;
}

export function AcceptInvitationPage({ onClickCreate, inviteToken }: Props) {
  return (
    <Background>
      <Container>
        <Stack direction="row" justifyContent="space-between" paddingTop="32px">
          <TestTheTestBrandLink />
          <img width={400} src="/assets/images/signup-bird.png" alt="" />
        </Stack>

        <Typography
          color="white"
          position="absolute"
          top="50%"
          fontSize={[60, 100, 120]}
          fontWeight={800}
          maxWidth={940}
          lineHeight={1}
          sx={{ transform: "translate(0, -50%)" }}
        >
          Welcome to your best app yet
        </Typography>
      </Container>

      <Box
        position="absolute"
        bottom={0}
        width="100%"
        sx={{
          background: `linear-gradient(138.35deg, rgba(253, 177, 178, 0.9) -0.34%, rgba(254, 215, 156, 0.9) 96.05%)`,
        }}
      >
        <Container>
          <Stack alignItems="stretch" direction="row">
            <Stack spacing={2} flexGrow={1} paddingY={3.5} flex={1}>
              {inviteToken && <InvitedText inviteToken={inviteToken} />}

              <div>
                <PrettyButton onClick={onClickCreate}>
                  Create account
                </PrettyButton>
              </div>
            </Stack>

            <Box marginTop={-3.5}>
              <img src="/assets/images/peace-symbol.svg" alt="" height="100%" />
            </Box>
          </Stack>
        </Container>
      </Box>
    </Background>
  );
}
